import React from 'react';
import { useLang } from '../lib/i18n';
import { demoCopy } from '../lib/demo-copy';
import { resetDemo } from '../lib/api';
export default function DemoBanner(){
 const {lang}=useLang();const text=demoCopy[lang]||demoCopy.en;
 return <aside className="bg-[#15130c] border-b border-gold/25 text-[#e7d490]" aria-label="Demo" data-testid="demo-banner"><div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between gap-3 text-sm"><p>{text.banner}</p><button onClick={()=>{resetDemo();window.location.reload();}} className="shrink-0 underline underline-offset-4 hover:text-white" data-testid="reset-demo">{text.reset}</button></div></aside>;
}
